import styles from "../../../../../styles/Participant-Employment.module.css"
import { RadioButton } from "primereact/radiobutton"

const MilitaryBranch = ({ label, value, setValue, valueName, disabled }) => {
  return (
    <div className={styles.field}>
      <label className={styles.label} style={{ marginBottom: "5px" }}>
        {label}
      </label>
      <div className={styles.radio_btn_wrapper}>
        <div className={styles.radio_btn}>
          <RadioButton
            inputId={`air_force`}
            value={"Air force"}
            style={{ margin: "0" }}
            onChange={(e) => {
              setValue(valueName, e.value)
            }}
            disabled={disabled}
            checked={value === "Air force"}
          />
          <label htmlFor={`air_force`} className={styles.inline_label}>
            Air force
          </label>
        </div>
        <div className={styles.radio_btn}>
          <RadioButton
            inputId={`army`}
            value={"Army"}
            style={{ margin: "0" }}
            onChange={(e) => {
              setValue(valueName, e.value)
            }}
            disabled={disabled}
            checked={value === "Army"}
          />
          <label htmlFor={`Army`} className={styles.inline_label}>
            Army
          </label>
        </div>
        <div className={styles.radio_btn}>
          <RadioButton
            inputId={`coast_guard`}
            value={"Coast Guard"}
            style={{ margin: "0" }}
            onChange={(e) => {
              setValue(valueName, e.value)
            }}
            disabled={disabled}
            checked={value === "Coast Guard"}
          />
          <label htmlFor={`coast_guard`} className={styles.inline_label}>
            Coast Guard
          </label>
        </div>
        <div className={styles.radio_btn}>
          <RadioButton
            inputId={`marine_corps`}
            value={"Marine Corps"}
            style={{ margin: "0" }}
            onChange={(e) => {
              setValue(valueName, e.value)
            }}
            disabled={disabled}
            checked={value === "Marine Corps"}
          />
          <label htmlFor={`marine_corps`} className={styles.inline_label}>
            Marine Corps
          </label>
        </div>
        <div className={styles.radio_btn}>
          <RadioButton
            inputId={`navy`}
            value={"Navy"}
            style={{ margin: "0" }}
            onChange={(e) => {
              setValue(valueName, e.value)
            }}
            disabled={disabled}
            checked={value === "Navy"}
          />
          <label htmlFor={`navy`} className={styles.inline_label}>
            Navy
          </label>
        </div>
        <div className={styles.radio_btn}>
          <RadioButton
            inputId={`space_force`}
            value={"Space Force"}
            style={{ margin: "0" }}
            onChange={(e) => {
              setValue(valueName, e.value)
            }}
            disabled={disabled}
            checked={value === "Space Force"}
          />
          <label htmlFor={`space_force`} className={styles.inline_label}>
            Space Force
          </label>
        </div>
      </div>
    </div>
  )
}
export default MilitaryBranch
